import * as FormNames from './formNames';
import { BASE_PATH, AppConstants, TrackValues } from './constants';
import { getData } from './sessionStorage';
import { trackPageView } from './monitoring';

export const getPrimaryTrackPageName = () => {
  const primaryTrack = getData(AppConstants.primaryTrack);
  const { SWE, WebDev, Data, Design, Marketing, Sales } = TrackValues;

  switch (primaryTrack) {
    case SWE:
      return FormNames.SoftwareEngineering;
    case WebDev:
      return FormNames.WebDevelopment;
    case Data:
      return FormNames.DataScience;
    case Design:
      return FormNames.Design;
    case Marketing:
      return FormNames.Marketing;
    case Sales:
      return FormNames.Sales;
    default:
      return `${primaryTrack} Page`;
  }
};

export const getPageName = (path) => {
  if (path === '') {
    return FormNames.ApplyPageForm;
  }
  switch (path) {
    case '/':
      return FormNames.ApplyPageForm;
    case '/1':
      return FormNames.JobProfile;
    case '/s/1':
      return `${FormNames.JobProfile} Slowform`;
    case '/2':
      return FormNames.PrimaryTrack;
    case '/s/2':
      return `${FormNames.PrimaryTrack} Slowform`;
    case '/3':
      return FormNames.EducationEmployment;
    case '/s/3':
      return `${FormNames.EducationEmployment} Slowform`;
    case '/4':
      return getPrimaryTrackPageName();
    case '/s/4':
      return `${getPrimaryTrackPageName()} Slowform`;
    case '/5':
      return FormNames.EqualEmploymentOpportunity;
    case '/s/5':
      return `${FormNames.EqualEmploymentOpportunity} Slowform`;
    case '/6':
      return 'Form Success Redirect';
    case '/s/6':
      return 'Form Success Redirect Slowform';
    case '/s/error':
      return 'Slow Enrollment Error';
    case '/s/redirect':
      return 'Slow Enrollment Redirect';
    default:
      return 'Not Found Page';
  }
};

export const handleBrowserNav = (history, historyLocation, locationKeys, setLocationKeys) => {
  const href = window.location.origin + BASE_PATH + historyLocation.pathname;
  const pageName = getPageName(historyLocation.pathname);
  let referrer = historyLocation?.state?.from ?? '';
  if (history.action === 'PUSH') {
    setLocationKeys([{ key: historyLocation.key, href }]);
  }

  if (history.action === 'POP') {
    const key = locationKeys[1]?.key ?? AppConstants.rootLocationKey;
    if (key === historyLocation.key) {
      // Handle forward event
      const [_, ...newKeys] = locationKeys;
      setLocationKeys(newKeys);
    } else {
      // Handle back event
      const newKeys = [{ key: historyLocation.key, href }, ...locationKeys];
      setLocationKeys(newKeys);
    }
    referrer = locationKeys[0]?.href;
  }
  trackPageView({ pageName, referrer });
};
